import {useMemo} from 'react';

import {useRunsData} from '../../../state/runs/hooks';
import {toRunsDataQuery} from '../../../state/runs/lib';
import {UseRunSelectorRunsArgs} from './useRunSelectorRuns';

export const useRunsLowData = ({
  disabled,
  pageSize,
  topLevelQueryVariables,
  overrideOptions,
}: UseRunSelectorRunsArgs) => {
  const {shouldOnlyShowSelected} = overrideOptions ?? {};
  const query = useMemo(
    () =>
      toRunsDataQuery(
        topLevelQueryVariables,
        {selectionsAsFilters: shouldOnlyShowSelected},
        {
          disabled,
          page: {size: pageSize},
          historyKeyInfo: false,
        }
      ),
    [disabled, pageSize, topLevelQueryVariables, shouldOnlyShowSelected]
  );
  const {data} = useRunsData(query);
  return useMemo(
    () => ({
      isLoadingRuns: !disabled && (data.loading || data.initialLoading),
      loadMoreRuns: data.loadMore,
      runs: data.filtered,
      totalRuns: data.totalRuns,
    }),
    [data, disabled]
  );
};
